export const RIGHT_PINNED_COLUMNS = 0

// Maps column IDs to their 30-day sort equivalent when the 30D toggle is active
export const THIRTY_DAY_SORT_MAP = {
  margin: 'margin30',
  roi: 'roi30',
  profit: 'profit30',
  sellprice: 'sellprice30',
}

export const SORT_COLUMNS = [
  'margin',
  'roi',
  'profit',
  'margin30',
  'roi30',
  'profit30',
  'sellprice',
  'sellprice30',
  'buyprice',
  'salesrank',
  'percent_bsr',
  'confirmed_sales',
  'estimated_sales',
  'salesdrops',
  'variations',
  'offers',
  'brand',
]

// Columns added in this session that should only be sortable in wholesale mode
// Original sortable columns (all modules): salesrank, percent_bsr, buyprice, confirmed_sales, salesdrops, offers
export const WHOLESALE_ONLY_SORT_COLUMNS = new Set([
  'margin',
  'roi',
  'profit',
  'margin30',
  'roi30',
  'profit30',
  'sellprice',
  'sellprice30',
  'estimated_sales',
  'brand',
])

export const normalizeRegions = (value) => {
  if (Array.isArray(value)) {
    return value
  }
  if (value === undefined || value === null) {
    return []
  }
  return [value]
}

export const deriveRegionsFromData = (data) => {
  if (!data) {
    return []
  }

  const primary = data?.region ? String(data.region).toLowerCase() : null
  const extraRegions = new Set()

  data?.products?.forEach((product) => {
    Object.keys(product?.regions || {}).forEach((region) => {
      if (!region) {
        return
      }
      const normalized = region.toLowerCase()
      if (normalized !== primary) {
        extraRegions.add(normalized)
      }
    })
  })

  const sortedExtras = Array.from(extraRegions).sort()

  if (primary) {
    return [primary, ...sortedExtras]
  }

  return sortedExtras
}

export const arraysEqual = (a, b) => {
  if (a === b) {
    return true
  }
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false
  }
  if (a.length !== b.length) {
    return false
  }
  return a.every((value, index) => value === b[index])
}
